<script>
import {
    BTable
} from 'bootstrap-vue'
import Table from "@/views/table/bs-table/Table.vue";

export default {
    components: {Table, BTable},
    props: {
        explanation: {
            required: true
        }
    },
}
</script>

<template>
    <div>
        <h5>Comparison operators</h5>
        <b-table class="mb-2" striped hover :items="explanation.comparisonOperators"/>

        <h5>Logical operators</h5>
        <b-table class="mb-2" striped hover :items="explanation.logicalOperators"/>

        <h5>Arithmetic operators</h5>
        <b-table striped hover :items="explanation.arithmeticOperators"/>
    </div>
</template>
